import React from "react";

import { LocationOn, LocalPhone, Mail } from "@material-ui/icons";
import { FormattedMessage as Message } from "react-intl";

const ContactInfo = () => {
    return (
        <>
            <span className="top-bar__address--row">
                <span className="top-bar__address--row_icon">
                    <LocationOn />
                </span>
                <span className="top-bar__address--row_text">
                     <Message id="commons.address.ua.country" /> <br/>
                     <Message id="commons.address.ua.city" />
                </span>
            </span>
            <span className="top-bar__address--row">
                <span className="top-bar__address--row_icon">
                    <LocalPhone />
                </span>
                <span className="top-bar__address--row_text">
                    <a href="tel:+380372515489">+38-0372-515489</a>
                </span>
                <span className="top-bar__address--row_text">
                    <a href="tel:+380372515489">+38-050-2047840 </a>
                </span>
            </span>
            <span className="top-bar__email--row">
                <span className="top-bar__email--row_icon">
                    <Mail />
                </span>
                <span className="top-bar__email--row_text">
                    <a href={"mailto:promopecs@gmail.com"}>promopecs@gmail.com</a>
                </span>
            </span>
        </>
    )
};

export default ContactInfo
